module.exports = __webpack_public_path__ + "89465a4ec5b3005cf78f22a0fa8eebc6.fbx";